import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 200px;
	height: 100px;
	div {
		width: 85px;
		text-align: center;
		position: relative;
		z-index: 10;
		padding-left: 10px;
		padding-top: 12px;
		font-size: 16px;
		line-height: 18px;
		color: #fff;
		b {
			font-size: 24px;
			line-height: 28px;
		}
	}
	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		border-top: 50px solid #00f;
		border-left: 100px solid #00f;
		border-bottom: 50px solid transparent;
		border-right: 100px solid transparent;
	}
	&.size {
		width: 100px;
		height: 60px;
		div {
			width: 50px;
			padding-left: 2px;
			padding-top: 4px;
			font-size: 10px;
			line-height: 10px;
			b {
				font-size: 14px;
				line-height: 12px;
			}
		}
		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			display: block;
			border-top: 30px solid #00f;
			border-left: 50px solid #00f;
			border-bottom: 30px solid transparent;
			border-right: 50px solid transparent;
		}
	}
	@media (max-width: 1200px) {
		width: 140px;
		height: 70px;
		div {
			width: 65px;
			padding-left: 5px;
			padding-top: 7px;
			font-size: 11px;
			line-height: 12px;
			b {
				font-size: 16px;
				line-height: 16px;
			}
		}
		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			display: block;
			border-top: 35px solid #00f;
			border-left: 70px solid #00f;
			border-bottom: 35px solid transparent;
			border-right: 70px solid transparent;
		}
	}
`;

const Flag = (props) => {
	return (
		<Wrapper {...props}>
			<div>
				<b>100%</b>
				<br />
				FUNDED
			</div>
		</Wrapper>
	);
};

export default Flag;
